import React from "react";
import { cn } from "../../../lib/utils";
import { STATE_CLASSES } from "../theme/states";

/** A status pill with an already-translated label, in one of the semantic states (theme/states.js). */
export default function StatusBadge({ tone = "neutral", className, testId, children }) {
  return (
    <span data-testid={testId}
      className={cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs whitespace-nowrap", STATE_CLASSES[tone] || STATE_CLASSES.neutral, className)}>
      {children}
    </span>
  );
}

/** The pill state of an email send status; `null` for statuses shown as plain text. */
export const emailStatusTone = (status) => {
  if (status === "opened" || status === "delivered") return "positive";
  if (status === "bounced" || status === "complained" || status === "deferred_cap") return "warning";
  if (status === "failed") return "danger";
  return null;
};
